import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Actions\Admin\UpdateWelcomeMessage::__invoke
* @see app/Actions/Admin/UpdateWelcomeMessage.php:17
* @route '/admin/settings/welcome-message'
*/
const UpdateWelcomeMessage = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateWelcomeMessage.url(options),
    method: 'patch',
})

UpdateWelcomeMessage.definition = {
    methods: ["patch"],
    url: '/admin/settings/welcome-message',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Admin\UpdateWelcomeMessage::__invoke
* @see app/Actions/Admin/UpdateWelcomeMessage.php:17
* @route '/admin/settings/welcome-message'
*/
UpdateWelcomeMessage.url = (options?: RouteQueryOptions) => {
    return UpdateWelcomeMessage.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Admin\UpdateWelcomeMessage::__invoke
* @see app/Actions/Admin/UpdateWelcomeMessage.php:17
* @route '/admin/settings/welcome-message'
*/
UpdateWelcomeMessage.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: UpdateWelcomeMessage.url(options),
    method: 'patch',
})

export default UpdateWelcomeMessage